import initializeEnvBarScrollEffect from "./initializeEnvBarScrollEffect";
import { enableGtmGAUserIDTracking } from "../../common/functions/gtm";

const initializeBaseData = () => {
  insertToastFromCookies();
  return getBaseData().then((json) => {
    loadMauticTrackingTag(json);
    insertManageBar(json.current_user);
    insertCsrfMetaTag(json.csrf_meta);
    insertFlashMessage(json.flash);
    initializePersonSignIn(json.current_person);
    enableGtmGAUserIDTracking(json);
    return json;
  });
};

const getBaseData = () => {
  num_to_prevent_caches = String(new Date().getTime());
  return fetch(
    `${Routes.async_info_base_data_path()}?_=${num_to_prevent_caches}`
  ).then((response) => response.json());
};

const loadMauticTrackingTag = (json) => {
  const type = json.current_user ? "reg_users" : "members";
  if (type == "reg_users") {
    const primary_key_value = json.current_user
      ? { activo_id: json.current_user.id }
      : json.current_person
      ? {
          activo_member_id: json.current_person.member_id,
          email: json.current_person.email,
        }
      : {};
    (function (w, d, t, u, n, a, m) {
      w.MauticTrackingObject = n;
      (w[n] =
        w[n] ||
        function () {
          (w[n].q = w[n].q || []).push(arguments);
        }),
        (a = d.createElement(t)),
        (m = d.getElementsByTagName(t)[0]);
      a.async = 1;
      a.src = u;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      `${json.mautic_base_url}/${type}/mtc.js`,
      "mt"
    );
    mt("send", "pageview", primary_key_value);
  }
};

const insertManageBar = (current_user) => {
  if (current_user) {
    document.body.insertAdjacentHTML("beforeend", manageBarHtml(current_user));
    document.documentElement.classList.add("isShowManageBar");

    let lastScrollTop = 0;
    const manageHeader = document.getElementById("jsManageHeader");
    const scrollThreshold = 1;
    const minScrollHeight = 200; // NOTE: SPのheaderが200px以降に非表示になるため、それに合わせる

    window.addEventListener("scroll", () => {
      const currentScrollTop =
        window.scrollY || document.documentElement.scrollTop;
      const scrollDiff = Math.abs(currentScrollTop - lastScrollTop);

      if (currentScrollTop <= minScrollHeight) {
        manageHeader.classList.remove("hidden");
        return;
      }

      if (scrollDiff >= scrollThreshold) {
        if (currentScrollTop > lastScrollTop) {
          manageHeader.classList.add("hidden");
        } else {
          manageHeader.classList.remove("hidden");
        }
        lastScrollTop = currentScrollTop;
      }
    });

    // NOTE: manageHeaderが表示されるとき(=ログインしている時)にenvBarにもスクロールエフェクトを適用
    // TOPなどキャッシュされているページはextended_user_logged_in?が使えず、ログイン状態を判別できないため
    const envBar = document.getElementById("jsEnvBar");
    if (envBar) {
      initializeEnvBarScrollEffect();
    }
  }
};

const insertFlashMessage = (flash) => {
  if (flash) {
    $("#jsFlashZone").append(flashMessageHtml(flash));
  }
};

const insertToastFromCookies = () => {
  if (typeof Cookies === "undefined") {
    return;
  }
  const message = Cookies.get("toast_message");
  if (!message) {
    return;
  }
  const title = Cookies.get("toast_title") || "";
  const type = Cookies.get("toast_type") || "success";
  if (toastr[type]) {
    toastr[type](message, title);
  } else {
    toastr.success(message, title);
  }
  Cookies.remove("toast_message");
  Cookies.remove("toast_title");
  Cookies.remove("toast_type");
};

const flashMessageHtml = (flash) => {
  flash_messages = "";
  $.each(flash, (key, val) => {
    flash_message =
      `<div class='p_flashBox is${
        key.charAt(0).toUpperCase() + key.slice(1)
      }'>` +
      ` <p class='l_wrapper'>${val}</p>` +
      `</div>`;
    flash_messages += flash_message;
  });
  return flash_messages;
};

const manageBarHtml = (current_user) =>
  // NOTE: manage配下以外にも複数ページで使用されているため、js-routesを使わないでroutesを定義している。
  "" +
  `<header id="jsManageHeader" class='m_manageHeader clearFix'>` +
  `  <ul class='u_floatL'>` +
  `    <li><span class='manageLogo'></span></li>` +
  `    <li><a href='/manage/top' class='toManageTOP'>管理ページTOPへ</a></li>` +
  `  </ul>` +
  `  <ul class='u_floatR'>` +
  `    <li class='myAccount'>こんにちは。${current_user.name}様</li>` +
  `  </ul>` +
  `</header>`;

const insertCsrfMetaTag = (csrf_meta) => {
  $("<meta>")
    .attr("name", "csrf-param")
    .attr("content", csrf_meta.param)
    .appendTo("head");
  $("<meta>")
    .attr("name", "csrf-token")
    .attr("content", csrf_meta.token)
    .appendTo("head");
  $("form[method!=get]").append(
    `<input type="hidden" name="authenticity_token" value="${csrf_meta.token}">`
  );
};

const initializePersonSignIn = (current_person) => {
  if (current_person && document.querySelector(".jsRemoveWhenPersonSignedIn")) {
    $(".jsRemoveWhenPersonSignedIn").remove();
  }
};

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeBaseData;